// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"6fbeada6","135":"96a5ada3","197":"10e023bc","422":"7156da86","437":"3bb1ad39","832":"17a1d05b","900":"9b43de5d"}[chunkId] + ".chunk.js";
};